module.exports = __webpack_public_path__ + "img/story041@2x.1a826d0c.png";